"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLOORS = exports.AREA = exports.PRICE = exports.ROOMS = exports.BankSelectOptionValues = exports.DefaultBankOption = exports.DefaultBank = void 0;
var global_credit_svg_1 = __importDefault(require("../../images/icons/banks/global_credit.svg"));
var indeco_bank_png_1 = __importDefault(require("../../images/icons/banks/indeco_bank.png"));
var ararat_bank_png_1 = __importDefault(require("../../images/icons/banks/ararat_bank.png"));
var evoca_bank_png_1 = __importDefault(require("../../images/icons/banks/evoca_bank.png"));
var arcax_bank_png_1 = __importDefault(require("../../images/icons/banks/arcax_bank.png"));
var Id_bank_png_1 = __importDefault(require("../../images/icons/banks/Id_bank.png"));
var mellat_png_1 = __importDefault(require("../../images/icons/banks/mellat.png"));
var uni_bank_png_1 = __importDefault(require("../../images/icons/banks/uni_bank.png"));
var arm_business_bank_png_1 = __importDefault(require("../../images/icons/banks/arm_business_bank.png"));
var ardshin_bank_png_1 = __importDefault(require("../../images/icons/banks/ardshin_bank.png"));
var fast_credit_png_1 = __importDefault(require("../../images/icons/banks/fast_credit.png"));
var ameria_bank_png_1 = __importDefault(require("../../images/icons/banks/ameria_bank.png"));
var vtb_bank_png_1 = __importDefault(require("../../images/icons/banks/vtb_bank.png"));
var arm_econom_bank_png_1 = __importDefault(require("../../images/icons/banks/arm_econom_bank.png"));
var byblos_bank_png_1 = __importDefault(require("../../images/icons/banks/byblos_bank.png"));
var acba_bank_png_1 = __importDefault(require("../../images/icons/banks/acba_bank.png"));
var converse_bank_png_1 = __importDefault(require("../../images/icons/banks/converse_bank.png"));
var arm_swis_bank_png_1 = __importDefault(require("../../images/icons/banks/arm_swis_bank.png"));
var aregak_bank_png_1 = __importDefault(require("../../images/icons/banks/aregak_bank.png"));
var kamurj_bank_png_1 = __importDefault(require("../../images/icons/banks/kamurj_bank.png"));
var hsbc_bank_png_1 = __importDefault(require("../../images/icons/banks/hsbc-bank.png"));
exports.DefaultBank = {
    id: Date.now(),
    is_exclusive: '',
    key: Date.now(),
    max_duration: 240,
    min_percent: '12',
    min_prepayment: '15',
    mortgage_programs: [],
    name: 'MORTGAGE_BANKS.GLOBAL_CREDIT',
    post_id: '',
    text: 'Global Credit',
    value: 'MORTGAGE_BANKS.GLOBAL_CREDIT',
    image: { avatar: true, src: global_credit_svg_1.default },
};
exports.DefaultBankOption = {
    key: '0',
    text: 'MORTGAGE_BANKS.GLOBAL_CREDIT',
    value: 'Global Credit',
    image: { avatar: true, src: global_credit_svg_1.default },
};
//@TODO need to check SVG required or not, some svg have big sizes!
exports.BankSelectOptionValues = [
    exports.DefaultBankOption,
    {
        key: '1',
        text: 'MORTGAGE_BANKS.ACBA_BANK',
        value: 'Acba Bank',
        image: { avatar: true, src: acba_bank_png_1.default },
    },
    {
        key: '2',
        text: 'MORTGAGE_BANKS.ID_BANK',
        value: 'ID Bank',
        image: { avatar: true, src: Id_bank_png_1.default },
    },
    {
        key: '3',
        text: 'MORTGAGE_BANKS.ARARAT_BANK',
        value: 'Ararat Bank',
        image: { avatar: true, src: ararat_bank_png_1.default },
    },
    {
        key: '4',
        text: 'MORTGAGE_BANKS.ARDSHIN_BANK',
        value: 'Ardshinbank',
        image: { avatar: true, src: ardshin_bank_png_1.default },
    },
    {
        key: '5',
        text: 'MORTGAGE_BANKS.ARM_SWISS_BANK',
        value: 'ArmSwissBank',
        image: { avatar: true, src: arm_swis_bank_png_1.default },
    },
    {
        key: '6',
        text: 'MORTGAGE_BANKS.ARTSAKH_BANK',
        value: 'Artsakhbank',
        image: { avatar: true, src: arcax_bank_png_1.default },
    },
    {
        key: '7',
        text: 'MORTGAGE_BANKS.BYBLOS_BANK',
        value: 'Byblos Bank Armenia',
        image: { avatar: true, src: byblos_bank_png_1.default },
    },
    {
        key: '8',
        text: 'MORTGAGE_BANKS.HSBC_BANK',
        value: 'HSBC Bank',
        image: { avatar: true, src: hsbc_bank_png_1.default },
    },
    {
        key: '9',
        text: 'MORTGAGE_BANKS.EVOKA_BANK',
        value: 'Evocabank',
        image: { avatar: true, src: evoca_bank_png_1.default },
    },
    {
        key: '10',
        text: 'MORTGAGE_BANKS.INECOBANK',
        value: 'Inecobank',
        image: { avatar: true, src: indeco_bank_png_1.default },
    },
    {
        key: '11',
        text: 'MORTGAGE_BANKS.CONVERSE_BANK',
        value: 'Converse Bank',
        image: { avatar: true, src: converse_bank_png_1.default },
    },
    {
        key: '12',
        text: 'MORTGAGE_BANKS.ARM_BUSINESS_BANK',
        value: 'ArmBusinessBank',
        image: { avatar: true, src: arm_business_bank_png_1.default },
    },
    {
        key: '13',
        text: 'MORTGAGE_BANKS.ARM_ECONOM_BANK',
        value: 'Armeconombank',
        image: { avatar: true, src: arm_econom_bank_png_1.default },
    },
    {
        key: '14',
        text: 'MORTGAGE_BANKS.MELLAT_BANK',
        value: 'Mellat Bank',
        image: { avatar: true, src: mellat_png_1.default },
    },
    {
        key: '15',
        text: 'MORTGAGE_BANKS.UNI_BANK',
        value: 'Unibank',
        image: { avatar: true, src: uni_bank_png_1.default },
    },
    {
        key: '16',
        text: 'MORTGAGE_BANKS.VTB_BANK',
        value: 'VTB Bank',
        image: { avatar: true, src: vtb_bank_png_1.default },
    },
    {
        key: '17',
        text: 'MORTGAGE_BANKS.THE_FIRST_MORTGAGE_COMPANY',
        value: 'The First Mortgage Company',
        image: { avatar: true, src: global_credit_svg_1.default },
    },
    {
        key: '18',
        text: 'MORTGAGE_BANKS.AREGAK',
        value: 'AREGAK',
        image: { avatar: true, src: aregak_bank_png_1.default },
    },
    {
        key: '19',
        text: 'MORTGAGE_BANKS.KAMURJ',
        value: 'Kamurj',
        image: { avatar: true, src: kamurj_bank_png_1.default },
    },
    {
        key: '20',
        text: 'MORTGAGE_BANKS.FAST_CREDIT',
        value: 'Fast Credit',
        image: { avatar: true, src: fast_credit_png_1.default },
    },
    {
        key: '21',
        text: 'MORTGAGE_BANKS.AMERIA_BANK',
        value: 'Ameria Bank',
        image: { avatar: true, src: ameria_bank_png_1.default },
    },
];
exports.ROOMS = [
    {
        key: '0',
        text: '1 Սենյականոց',
        value: '1 Սենյականոց',
    },
    {
        key: '1',
        text: '2 Սենյականոց',
        value: '2 Սենյականոց',
    },
    {
        key: '2',
        text: '3 Սենյականոց',
        value: '3 Սենյականոց',
    },
    {
        key: '3',
        text: '4 Սենյականոց',
        value: '4 Սենյականոց',
    },
];
exports.PRICE = [
    {
        key: '0',
        text: '1',
        value: '1',
    },
];
exports.AREA = [];
exports.FLOORS = [];
